const Theme = {
  ltr: "ltr",
  rtl: "rtl",
  placeholder: "editor-placeholder",
  quote: "editor-quote",
  heading: { h1: "editor-heading-h1", h2: "editor-heading-h2" },
  table: "table",
  tableCell: "tableCell",
  tableCellHeader: "tableCellHeader",
  tableCellSelected: "tableCellSelected",
  tableFrozenColumn: "tableFrozenColumn",
  tableFrozenRow: "tableFrozenRow",
  tableRowStriping: "tableRowStriping",
  tableScrollableWrapper: "tableScrollableWrapper",
  tableAlignment: {
    center: "tableAlignmentCenter",
    right: "tableAlignmentRight",
  },
  list: {
    nested: { listitem: "editor-nested-listitem" },
    ol: "editor-list-ol",
    ul: "editor-list-ul",
    listitem: "editor-listitem",
  },
  image: "editor-image",
  link: "editor-link",
  text: {
    overflowed: "editor-text-overflowed",
    hashtag: "editor-text-hashtag",
    bold: "editor-text-bold",
    underline: "editor-text-underline",
    strikethrough: "editor-text-strikethrough",
    underlineStrikethrough: "editor-text-underlineStrikethrough",
    code: "editor-text-code",
  },
  code: "editor-code",
  codeHighlight: {
    atrule: "editor-tokenAttr",
    attr: "editor-tokenAttr",
    boolean: "editor-tokenProperty",
    builtin: "editor-tokenSelector",
    cdata: "editor-tokenComment",
    char: "editor-tokenSelector",
    class: "editor-tokenFunction",
    "class-name": "editor-tokenFunction",
    comment: "editor-tokenComment",
    constant: "editor-tokenProperty",
    deleted: "editor-tokenProperty",
    doctype: "editor-tokenComment",
    entity: "editor-tokenOperator",
    function: "editor-tokenFunction",
    important: "editor-tokenVariable",
    inserted: "editor-tokenSelector",
    keyword: "editor-tokenAttr",
    namespace: "editor-tokenVariable",
    number: "editor-tokenProperty",
    operator: "editor-tokenOperator",
    prolog: "editor-tokenComment",
    property: "editor-tokenProperty",
    punctuation: "editor-tokenPunctuation",
    regex: "editor-tokenVariable",
    selector: "editor-tokenSelector",
    string: "editor-tokenSelector",
    symbol: "editor-tokenProperty",
    tag: "editor-tokenProperty",
    url: "editor-tokenOperator",
    variable: "editor-tokenVariable",
  },
};

export default Theme;
